export default __webpack_public_path__ + "static/media/travel.36089b87.png";